// extracted by mini-css-extract-plugin
export var aiChatCartContainer = "_di-2";
export var aiChatCartContainerExit = "_di-4";
export var aiChatContainerLarge = "_di-0";
export var aiChatContainerSmall = "_di-1";
export var aiChatIcon = "_di-6";
export var slideInFromRight = "_di-3";
export var slideOutToRight = "_di-5";